var EnsembleVideo = EnsembleVideo || {};
EnsembleVideo.Quiz = EnsembleVideo.Quiz || {};

(function ($) {
    'use strict';
    EnsembleVideo.Quiz.Results = (function () {
        var globalization = {
                dateTimeFormat: '',
                language: '',
                timeZone: ''
            },
            questions = {
                breadcrumbDom: null,
                reportWrapperDom: null,
                reportLoaderDom: null,
                reportErrorDom: null,
                focus: function () {
                    $('html, body').animate({
                        scrollTop: $(questions.breadcrumbDom).offset().top-60
                    }, 1000);
                },
                showLoader: function () {
                    $(questions.reportWrapperDom).empty();
                    $(questions.reportErrorDom).hide();
                    $(questions.reportLoaderDom).show();
                },
                hideLoader: function () {
                    $(questions.reportLoaderDom).hide();
                },
                showError: function () {
                    $(questions.reportWrapperDom).hide();
                    $(questions.reportLoaderDom).hide();
                    $(questions.reportErrorDom).show();
                },
                overview: {
                    tmplOverviewDom: null,
                    title: 'Results by Questions',
                    createBreadcrumb: function (focus) {
                        $(questions.breadcrumbDom)
                            .html('<li><i class="fa fa-question-circle fa-2x mr5"></i >' + this.title + '</li>');
					    if (focus) 
                                questions.focus();
                    },
                    generate: function (focus) {
                        $.ajax({
                            url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/questions/results',
                            context: this,
                            success: function (data) {
                                $.tmpl(this.tmplOverviewDom, data).appendTo(questions.reportWrapperDom);
                                var grid = $(questions.reportWrapperDom).find('#overview_question_table')
                                    .bootgrid({
                                        columnSelection: false,
                                        caseSensitive: false,
                                        labels: {
                                            all: "All",
                                            infos: "Showing {{ctx.start}} to {{ctx.end}} of {{ctx.total}} entries",
                                            noResults: "No available results",
                                            search: 'Search'
                                        },
                                        rowCount: [10, 25, 50, 100, -1],
                                        css: {
                                            pagination: 'pagination pagerCustom'
                                        },
                                        formatters: {
                                            "details": function (column, row) {
                                                return '<a href="#" aria-label="Question Results" tabindex="0" class="question-details"' +
                                                    ' data-question-key="' + row.questionKay + '"> <i class="fa fa-search fa-2x"/></a>';
                                            }
                                        },
                                        downloadSettings: {
                                            dropdownSettings: {
                                                icon: 'glyphicon-save-file',
                                                title: 'Download Results',
                                                links: [
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/questions/results/download.pdf'
                                                    },
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF (details included)',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/questions/results/download.pdf?includeDetails=true'
                                                    },
                                                    {
                                                        icon: 'fa fa-file-excel-o text-dark5',
                                                        text: 'CSV',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/questions/results/download.csv'
                                                    }
                                                ]
                                            }
                                        }
                                    })
                                    .on("loaded.rs.jquery.bootgrid", $.proxy(function (e) {
                                        if (!(data && data.questions && data.questions.length > 0)) {
                                            $(questions.reportWrapperDom).find('.actionBar').hide();
                                            $(questions.reportWrapperDom).find('.pagerCustom').hide();
                                        }

                                        $(grid).find('.question-details')
                                            .on('click', $.proxy(this.onDetailsClick, this))
                                            .on('focusin', function () {
                                                $(this).addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).removeClass('focus');
                                            });


                                        $(grid).find('.sortable')
                                            .on('focusin', function () {
                                                $(this).parent('.ev-sortable').addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).parent('.ev-sortable').removeClass('focus');
                                            });

                                        questions.reportWrapperDom.show();
                                        questions.hideLoader();
                                    }, this));
                            },
                            type: 'GET',
                            dataType: "json",
                            beforeSend: function () {
                                questions.overview.createBreadcrumb(focus);
                                questions.showLoader();
                            },
                            error: questions.showError
                        });
                    },
                    onDetailsClick: function (e) {
                        e.preventDefault();
                        var questionText = $(e.currentTarget).parents('tr').find('.question-text').text();
                        questions.details.generate.call(questions.details, $(e.currentTarget).data('question-key'), questionText, true);
                    },
                    init: function () {
                        this.tmplOverviewDom = $('#overviewTmpl');
                        $(questions.breadcrumbDom)
                            .on('click', '.back-to-question-owerview', $.proxy(this.generate, this, true))
                            .on('focusin', '.back-to-question-owerview', function () {
                                $(this).addClass('focus');
                            })
                            .on('focusout', '.back-to-question-owerview', function () {
                                $(this).removeClass('focus');
                            });
                    }
                },
                details: {
                    tmplQuestionDetailsDom: null,
                    title: 'Results by Question',
                    createBreadcrumb: function (questionText, focus) {
                        $(questions.breadcrumbDom).html('<li><a tabindex="0" href="#" class="btn bg-light2 btn-gradient back-to-question-owerview" aria-label="Results by Questions" title="Results by Questions"><i class="fa fa-arrow-left fa-2x"></i></a></li><li>' +
                            EnsembleVideo.Quiz.Results.Trim(questionText, 50) + '</li>').append($('<li>').text(this.title));
 					    if (focus) 
                           questions.focus();
                    },
                    generate: function (questionKey, questionText) {
                        $.ajax({
                            url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/Questions/' + questionKey + '/results',
                            context: this,
                            success: function (data) {
                                $.tmpl(this.tmplQuestionDetailsDom, data).appendTo(questions.reportWrapperDom);

                                var grid = $(questions.reportWrapperDom).find('#details_question_table')
                                    .bootgrid({
                                        columnSelection: false,
                                        caseSensitive: false,
                                        labels: {
                                            all: "All",
                                            infos: "Showing {{ctx.start}} to {{ctx.end}} of {{ctx.total}} entries",
                                            noResults: "No available results",
                                            search: 'Search'
                                        },
                                        rowCount: [10, 25, 50, 100, -1],
                                        css: {
                                            pagination: 'pagination pagerCustom'
                                        },
                                        formatters: {
                                            "status": function (column, row) {
                                                var isCorrect = $.trim(row.isCorrect).toLowerCase() == 'true';
                                                return '<i class="fa fa-2x ' + (isCorrect ? 'fa-check text-green2' : 'fa-times text-red2') + '" aria-label="' + (isCorrect ? 'Correct' : 'Incorrect') + '"></i>';
                                            }
                                        },
                                        converters: {
                                            datetime: {
                                                from: function (value) { return moment.utc(value).tz(globalization.timeZone); },
                                                to: function(value) { return value.format(globalization.dateTimeFormat); }
                                            }
                                        },
                                        downloadSettings: {
                                            dropdownSettings: {
                                                icon: 'glyphicon-save-file',
                                                title: 'Download Results',
                                                links: [
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/Questions/' + questionKey + '/results/download.pdf'
                                                    },
                                                    {
                                                        icon: 'fa fa-file-excel-o text-dark5',
                                                        text: 'CSV',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/Questions/' + questionKey + '/results/download.csv'
                                                    }
                                                ]
                                            }
                                        }
                                    })
                                    .on("loaded.rs.jquery.bootgrid", function (e) {
                                        if (!(data && data.answers && data.answers.length > 0)) {
                                            $(questions.reportWrapperDom).find('.actionBar').hide();
                                            $(questions.reportWrapperDom).find('.pagerCustom').hide();
                                        }


                                        $(grid).find('.sortable')
                                            .on('focusin', function () {
                                                $(this).parent('.ev-sortable').addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).parent('.ev-sortable').removeClass('focus');
                                            });

                                        questions.hideLoader();
                                        questions.reportWrapperDom.show();
                                    });
                            },
                            type: 'GET',
                            dataType: "json",
                            beforeSend: function () {
                                questions.details.createBreadcrumb(questionText, focus);
                                questions.showLoader();
                            },
                            error: questions.showError
                        });
                    },
                    init: function () {
                        this.tmplQuestionDetailsDom = $('#questionDetailsTmpl');
                    }
                },
                init: function () {
                    this.breadcrumbDom = $('ol#question_breadcrumb');
                    this.reportWrapperDom = $('div#quiz_results_question_container');
                    this.reportLoaderDom = $('div#quiz_results_question_loader');
                    this.reportErrorDom = $('div#quiz_results_question_error');
                    this.overview.init();
                    this.details.init();
                }
            },
            users = {
                breadcrumbDom: null,
                reportWrapperDom: null,
                reportLoaderDom: null,
                reportErrorDom: null,
                showLoader: function () {
                    $(users.reportWrapperDom).empty();
                    $(users.reportErrorDom).hide();
                    $(users.reportLoaderDom).show();
                },
                focus: function () {
                    $('html, body').animate({
                        scrollTop: $(users.breadcrumbDom).offset().top-60
                    }, 1000);
                },
                hideLoader: function () {
                    $(users.reportLoaderDom).hide();
                },
                showError: function () {
                    $(users.reportWrapperDom).hide();
                    $(users.reportLoaderDom).hide();
                    $(users.reportErrorDom).show();
                },
                overview: {
                    tmplOverviewDom: null,
                    title: 'Results by Users',
                    createBreadcrumb: function (focus) {
                        $(users.breadcrumbDom)
                            .html('<li><i class="fa fa-users fa-2x mr5"></i >' + this.title + '</li>');
						if (focus)
                            users.focus();
                    },
                    generate: function (focus) {
                        users.details.reset();
                        $.ajax({
                            url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/results',
                            context: this,
                            success: function (data) {
                                $.tmpl(this.tmplOverviewDom, data).appendTo(users.reportWrapperDom);
                                var grid = $(users.reportWrapperDom).find('#overview_user_table')
                                    .bootgrid({
                                        columnSelection: false,
                                        caseSensitive: false,
                                        labels: {
                                            all: "All",
                                            infos: "Showing {{ctx.start}} to {{ctx.end}} of {{ctx.total}} entries",
                                            noResults: "No available results",
                                            search: 'Search'
                                        },
                                        rowCount: [10, 25, 50, 100, -1],
                                        css: {
                                            pagination: 'pagination pagerCustom'
                                        },
                                        formatters: {
                                            "details": function (column, row) {
                                                return '<a href="#" aria-label="User Results" tabindex="0" class="question-details"' +
                                                    ' data-user-key="' + row.userId + '"> <i class="fa fa-search fa-2x"/></a>';
                                            }
                                        },
                                        downloadSettings: {
                                            dropdownSettings: {
                                                icon: 'glyphicon-save-file',
                                                title: 'Download Results',
                                                links: [
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/results/download.pdf'
                                                    },
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF (details included)',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/results/download.pdf?includeDetails=true'
                                                    },
                                                    {
                                                        icon: 'fa fa-file-excel-o text-dark5',
                                                        text: 'CSV',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/results/download.csv'
                                                    }
                                                ]
                                            }
                                        }
                                    })
                                    .on("loaded.rs.jquery.bootgrid", $.proxy(function (e) {
                                        if (!(data && data.users && data.users.length > 0)) {
                                            $(users.reportWrapperDom).find('.actionBar').hide();
                                            $(users.reportWrapperDom).find('.pagerCustom').hide();
                                        }

                                        $(grid).find('.question-details')
                                            .on('click', $.proxy(this.onDetailsClick, this))
                                            .on('focusin', function () {
                                                $(this).addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).removeClass('focus');
                                            });

                                        $(grid).find('.sortable')
                                            .on('focusin', function () {
                                                $(this).parent('.ev-sortable').addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).parent('.ev-sortable').removeClass('focus');
                                            });

                                        users.reportWrapperDom.show();
                                        users.hideLoader();
                                    }, this));
                            },
                            type: 'GET',
                            dataType: "json",
                            beforeSend: function () {
                                users.overview.createBreadcrumb(focus);
                                users.showLoader();
                            },
                            error: users.showError
                        });
                    },
                    onDetailsClick: function (e) {
                        e.preventDefault();

                        users.details.userId = $(e.currentTarget).data('user-key');
                        users.details.fullName = $(e.currentTarget).parents('tr').find('.full-name-text').text();
                        users.details.generate.call(users.details);
                    },
                    init: function () {
                        this.tmplOverviewDom = $('#userOverviewTmpl');
                        $(users.breadcrumbDom)
                            .on('click', '.back-to-users-owerview', $.proxy(this.generate, this))
                            .on('focusin', '.back-to-users-owerview', function () {
                                $(this).addClass('focus');
                            })
                            .on('focusout', '.back-to-users-owerview', function () {
                                $(this).removeClass('focus');
                            });
                    }
                },
                details: {
                    tmplUserDetailsDom: null,
                    attemptsTmplDom: null,
                    customControlsPlaceHolderDom: null,
                    userId: '',
                    fullName: '',
                    totalAttempts:0,
                    filterAttempt: '-1',
                    title: 'Results by User',
                    createBreadcrumb: function (fullName, focus) {
                        $(users.breadcrumbDom).html('<li><a  tabindex="0" class="btn bg-light2 btn-gradient back-to-users-owerview" href="#" aria-label="Results by Users" title="Results by Users"><i class="fa fa-arrow-left fa-2x"></i></a></li><li>' +
                            EnsembleVideo.Quiz.Results.Trim(fullName, 50) + '</li>').append($('<li>').text(this.title));
						if (focus)
                            users.focus();
                    },
                    createAttemptDropdown: function (totalAttempts) {
                        if (!totalAttempts || isNaN(totalAttempts))
                            return;

                        if (this.filterAttempt == '-1') {
                            this.totalAttempts = totalAttempts;
                        }

                        var data = {
                            attempts: [],
                            selected: this.filterAttempt
                        }

                        for (var i = 1; i <= this.totalAttempts; i++) {
                            data.attempts.push(i);
                        }

                        var placeHolder = $(users.reportWrapperDom).find(this.customControlsPlaceHolderSelector);
                        $(placeHolder).empty();
                        $.tmpl(this.attemptsTmplDom, data).appendTo(placeHolder);
                    },
                    generate: function (focus) {
                        var queryParameters = (this.filterAttempt != '-1') ? '?attempt=' + (this.filterAttempt) : '';
                        $.ajax({
                            url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/' + this.userId + '/results' + queryParameters,
                            context: this,
                            success: function (data) {
                                $.tmpl(this.tmplQuestionDetailsDom, data).appendTo(users.reportWrapperDom);

                                var grid = $(users.reportWrapperDom).find('#details_user_table')
                                    .bootgrid({
                                        columnSelection: false,
                                        caseSensitive: false,
                                        labels: {
                                            all: "All",
                                            infos: "Showing {{ctx.start}} to {{ctx.end}} of {{ctx.total}} entries",
                                            noResults: "No available results",
                                            search: 'Search'
                                        },
                                        rowCount: [10, 25, 50, 100, -1],
                                        css: {
                                            pagination: 'pagination pagerCustom'
                                        },
                                        formatters: {
                                            "status": function (column, row) {
                                                var isCorrect = $.trim(row.isCorrect).toLowerCase() == 'true';
                                                return '<i class="fa fa-2x ' + (isCorrect ? 'fa-check text-green2' : 'fa-times text-red2') + '" aria-label="' + (isCorrect ? 'Correct' : 'Incorrect') + '" ></i>';
                                            }
                                        },
                                        converters: {
                                            datetime: {
                                                from: function (value) { return moment.utc(value).tz(globalization.timeZone); },
                                                to: function(value) { return value.format(globalization.dateTimeFormat); }
                                            }
                                        },
                                        downloadSettings: {
                                            dropdownSettings: {
                                                icon: 'glyphicon-save-file',
                                                title: 'Download Results',
                                                links: [
                                                    {
                                                        icon: 'fa fa-file-pdf-o text-dark5',
                                                        text: 'PDF',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/' + this.userId + '/results/download.pdf' + queryParameters
                                                    },
                                                    {
                                                        icon: 'fa fa-file-excel-o text-dark5',
                                                        text: 'CSV',
                                                        url: '/hapi/v1/Contents/' + contentId + '/Quizzes/' + quizKey + '/users/' + this.userId + '/results/download.csv' + queryParameters
                                                    }
                                                ]
                                            }
                                        }
                                    })
                                    .on("loaded.rs.jquery.bootgrid", $.proxy(function (e) {
                                        if (data && data.attempts && data.attempts.length > 0) {
                                            this.createAttemptDropdown(data.attempts.length);
                                        } else {
                                            $(users.reportWrapperDom).find('.actionBar').hide();
                                            $(users.reportWrapperDom).find('.pagerCustom').hide();
                                        }

                                        $(grid).find('.sortable')
                                            .on('focusin', function () {
                                                $(this).parent('.ev-sortable').addClass('focus');
                                            })
                                            .on('focusout', function () {
                                                $(this).parent('.ev-sortable').removeClass('focus');
                                            });

                                        users.hideLoader();
                                        users.reportWrapperDom.show();
                                    }, this));
                            },
                            type: 'GET',
                            dataType: "json",
                            beforeSend: function () {
                                this.createBreadcrumb(this.fullName, focus);
                                users.showLoader();
                            },
                            error: this.showError
                        });
                    },
                    reset: function () {
                        this.userId = '';
                        this.fullName = '';
                        this.filterAttempt = '-1';
                    },
                    init: function () {
                        this.tmplQuestionDetailsDom = $('#userDetailsTmpl');
                        this.attemptsTmplDom = $('#attemptsTmpl');
                        this.customControlsPlaceHolderSelector = '.custom-controls';

                        $(users.reportWrapperDom).on('click', '.attempt-dropdown-item-button', $.proxy(function (e) {
                            this.filterAttempt = $(e.currentTarget).data('value');
                            this.generate();
                            e.preventDefault();
                        }, this));
                    }
                },

                init: function () {
                    this.breadcrumbDom = $('ol#user_breadcrumb');
                    this.reportWrapperDom = $('div#quiz_results_user_container');
                    this.reportLoaderDom = $('div#quiz_results_user_loader');
                    this.reportErrorDom = $('div#quiz_results_user_error');

                    this.overview.init();
                    this.details.init();
                }
            },
            deleteResults = {
                deleteResultsDom: null,

                confirmDeleteResults: function (e) {
                    this.configConfirmModalForDeleteResults();
                    this.bodyContentDom.empty().append(this.messages.modalMessageForDeleteResults);
                    this.confirmModalDom.modal('show');
                },
                configConfirmModalForDeleteResults: function () {
                    var self = this;

                    this.confirmModalDom.on('show.bs.modal', function (e) {
                        $(this).find('.btn-ok').off().on('click', function () {
                            self.deleteQuizResults();
                            self.confirmModalDom.modal('hide');
                        });
                    });
                },
                deleteQuizResults: function (e) {
                    jQuery.ajax({
                        beforeSend: function () {
                            
                        },
                        complete: function () {
                        },
                        cache: false,
                        url: '/hapi/v1/Bulk/Quizzes/DeleteResults',
                        type: 'DELETE',
                        dataType: 'json',
                        data: {
                            quizKeys: quizKey
                        },
                        success: jQuery.proxy(function (response) {
                                EnsembleVideo.Quiz.Results.Questions.overview.generate();
                                EnsembleVideo.Quiz.Results.Users.overview.generate();
                            },
                            this),
                        error: jQuery.proxy(function (response) {
                            },
                            this)
                    });

                },
                messages: {
                    modalMessageForDeleteResults: '<span>Are you sure you want to delete quiz results?</span>'
                },
                init: function () {
                    this.deleteResultsDom = $('a#deleteResults');
                    this.confirmModalDom = $('#confirmModal');
                    this.bodyContentDom = $('.bodyContent');

                    
                    this.deleteResultsDom.on('click', this.confirmDeleteResults.bind(this));
                }
            },
            contentId,
            quizKey,
            percentage = function (totalAnswered, correctAnswered) {
                if (totalAnswered == 0)
                    return 0;

                return Math.floor((correctAnswered / totalAnswered) * 100);
            },
            trim = function (textToTrim, numberOfChars) {
                if (textToTrim == null)
                    return '';
                textToTrim = $.trim(textToTrim);
                return textToTrim.length > numberOfChars ? textToTrim.substring(0, numberOfChars) + '...' : textToTrim;
            },
            init = function () {
                $.ajax({
                    cache: false
                });
                
                questions.init();
                users.init();
                deleteResults.init();

                contentId = $(questions.reportWrapperDom).data('content-id');
                quizKey = $(questions.reportWrapperDom).data('quiz-key');


                globalization.dateTimeFormat = GetUserDateTimeFormat();
                globalization.language = GetLanguage();
                globalization.timeZone = GetUserTimeZone();

                moment.locale(globalization.language);
                moment.tz.setDefault(globalization.timeZone);

                questions.overview.generate();
                users.overview.generate();
            };

        return {
            Init: init,
            Percentage: percentage,
            Trim: trim,
            Questions: questions,
            Users: users
        };

    })();

    $(document).ready(EnsembleVideo.Quiz.Results.Init);
}(jQuery));


